(() => {
  'use strict';

  const translations = {
    'availability': 'Disponibilité',
    'price': 'Prix',
    'product type': 'Type de produit',
    'vendor': 'Marque',
    'brand': 'Marque',
    'color': 'Couleur',
    'colour': 'Couleur',
    'size': 'Taille',
    'in stock': 'En stock',
    'out of stock': 'Épuisé',
    'available': 'Disponible',
    'unavailable': 'Indisponible',
    'featured': 'En vedette',
    'best selling': 'Meilleures ventes',
    'alphabetically, a-z': 'Nom : A à Z',
    'alphabetically, z-a': 'Nom : Z à A',
    'price, low to high': 'Prix : croissant',
    'price, high to low': 'Prix : décroissant',
    'date, old to new': 'Date : plus anciens',
    'date, new to old': 'Date : plus récents',
    'previous': 'Précédent',
    'next': 'Suivant',
    'previous page': 'Page précédente',
    'next page': 'Page suivante',
    'add to cart': 'Ajouter au panier',
    'sold out': 'Épuisé',
    'buy it now': 'Acheter maintenant',
    'checkout': 'Commander',
    'view cart': 'Voir le panier',
    'cart': 'Panier',
    'search': 'Rechercher',
    'close': 'Fermer',
    'apply': 'Appliquer',
    'clear': 'Effacer',
    'clear all': 'Tout effacer',
    'filter': 'Filtrer',
    'filters': 'Filtres',
    'sort by': 'Trier par',
    'remove': 'Retirer',
    'quantity': 'Quantité',
    'loading...': 'Chargement…',
    'loading…': 'Chargement…',
    'select options': 'Choisir les options',
    'choose options': 'Choisir les options',
    'view product': 'Voir le produit',
    'view full details': 'Voir tous les détails',
    'quick add': 'Ajout rapide',
    'continue shopping': 'Continuer mes achats'
  };

  const sortByValue = {
    'manual': 'En vedette',
    'best-selling': 'Meilleures ventes',
    'title-ascending': 'Nom : A à Z',
    'title-descending': 'Nom : Z à A',
    'price-ascending': 'Prix : croissant',
    'price-descending': 'Prix : décroissant',
    'created-ascending': 'Date : plus anciens',
    'created-descending': 'Date : plus récents'
  };

  const normalize = (text) => String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function translated(text) {
    const raw = String(text || '').trim();
    const direct = translations[normalize(raw)];
    if (direct) return direct;

    const pagination = raw.match(/^([«‹]\s*)?(previous|next)(\s*[»›])?$/i);
    if (pagination) {
      const label = normalize(pagination[2]) === 'previous' ? 'Précédent' : 'Suivant';
      return `${pagination[1] || ''}${label}${pagination[3] || ''}`.trim();
    }

    const counted = raw.match(/^(.*?)\s*\((\d+)\)$/);
    if (counted) {
      const base = translations[normalize(counted[1])];
      if (base) return `${base} (${counted[2]})`;
    }

    const chip = raw.match(/^(.*?)\s*×$/);
    if (chip) {
      const base = translations[normalize(chip[1])];
      if (base) return `${base} ×`;
    }

    const arrowRight = raw.match(/^(.*?)\s*([↗→])$/);
    if (arrowRight) {
      const base = translations[normalize(arrowRight[1])];
      if (base) return `${base} ${arrowRight[2]}`;
    }

    const arrowLeft = raw.match(/^([←])\s*(.*?)$/);
    if (arrowLeft) {
      const base = translations[normalize(arrowLeft[2])];
      if (base) return `${arrowLeft[1]} ${base}`;
    }

    return null;
  }

  function translateSimpleElement(el) {
    if (!el) return;

    if (el instanceof HTMLInputElement && ['submit', 'button'].includes(el.type)) {
      const next = translated(el.value);
      if (next) el.value = next;
      return;
    }

    if (el.children.length > 0) return;
    const next = translated(el.textContent);
    if (next) el.textContent = next;
  }

  function translateAttributes(el) {
    ['aria-label', 'title'].forEach((attr) => {
      if (!el.hasAttribute || !el.hasAttribute(attr)) return;
      const next = translated(el.getAttribute(attr));
      if (next) el.setAttribute(attr, next);
    });
  }

  function setupFilterControls(root = document) {
    root.querySelectorAll?.('.collection-controls').forEach((controls, index) => {
      const button = controls.querySelector('[data-filter-toggle]');
      const panel = controls.querySelector('[data-filter-panel]');
      if (!button || !panel) return;

      if (!panel.id) {
        panel.id = `${controls.id || `CollectionFilters-${index + 1}`}Panel`;
      }
      button.setAttribute('aria-controls', panel.id);

      const hasActiveFilters = Boolean(controls.querySelector('.active-filters a'));
      if (hasActiveFilters) {
        button.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  }

  function run(root = document) {
    root.querySelectorAll?.('#SortBy option').forEach((option) => {
      option.textContent = sortByValue[option.value] || translated(option.textContent) || option.textContent;
    });

    root.querySelectorAll?.('.collection-filters summary, .filter-values span, .active-filters a, .pagination a, .pagination span').forEach(translateSimpleElement);

    root.querySelectorAll?.('button, input[type="submit"], input[type="button"], [role="button"], .shopify-payment-button__button').forEach((el) => {
      translateSimpleElement(el);
      translateAttributes(el);
    });

    root.querySelectorAll?.('[aria-label], [title]').forEach(translateAttributes);
    setupFilterControls(root);
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const filterButton = target?.closest('[data-filter-toggle]');
    if (!filterButton) return;

    const controls = filterButton.closest('.collection-controls');
    const panelId = filterButton.getAttribute('aria-controls');
    const panel = (panelId && document.getElementById(panelId))
      || controls?.querySelector('[data-filter-panel]');

    if (!panel) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const nextOpen = filterButton.getAttribute('aria-expanded') !== 'true';
    filterButton.setAttribute('aria-expanded', String(nextOpen));
    panel.hidden = !nextOpen;
  }, true);

  function observeDynamicListing() {
    const body = document.body;
    const dynamicListing = body?.classList.contains('template-collection') || body?.classList.contains('template-search');
    const main = document.getElementById('MainContent');
    if (!dynamicListing || !main) return;

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        run(main);
      });
    };

    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  }

  const boot = () => {
    run(document);
    observeDynamicListing();
  };

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) run(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
